import React from "react"
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material"

import { AppCardTitle } from "@components"
import { ACRISS_GROUP_BY_OPTIONS } from "@constants"
import { acrissGroupBy, offices } from "@signals"
import { dsColorNew } from "@palette"
import { oneWayData, oneWayPriceMode } from "Pages/AnalyzersV2/OneWay/@signals"
import { oneWayAxisLabel } from "./axis"

export default function OneWayTableTitle() {
	const pickupName = oneWayData.value?.pickupName
	const dropoffName = oneWayData.value?.dropoffName
	const groupByLabel = ACRISS_GROUP_BY_OPTIONS.find(x => x.value === acrissGroupBy.value)?.label ?? 'acriss'
	const axisLabel = oneWayAxisLabel().toLowerCase()

	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, width: '100%', mb: 1.5 }}>
		<AppCardTitle
			icon="table-cells"
			title="One Way Fee"
			subtitle={`Minimum one-way fee per matched car (${pickupName ?? 'pickup'}-${dropoffName ?? 'dropoff'} minus ${pickupName ?? 'pickup'}-${pickupName ?? 'pickup'}, same provider, car, site, date and LOR), per ${axisLabel} and grouped by ${groupByLabel.toLowerCase()}.`}
		/>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 3, ml: 'auto' }}>
			<FormControlLabel
				sx={{ mr: 0 }}
				control={
					<Checkbox
						size="small"
						checked={oneWayPriceMode.value === 'roundTrip'}
						onChange={e => oneWayPriceMode.value = e.target.checked ? 'roundTrip' : 'oneWay'}
					/>
				}
				label={<Typography sx={{ fontSize: 13, color: dsColorNew.textDark }}>Round Trip Price</Typography>}
			/>
			{!!offices.value && <Typography sx={{ fontSize: 12, color: dsColorNew.textMuted }}>
				Baseline: same office as pickup
			</Typography>}
		</Box>
	</Box>
}
